// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { constants } from "@pacific/XDL/constants";
import Close from "@pacific/XDL/Icons/Close";
import { xBaseTheme } from "@pacific/XDL/types";
import { color } from "@pacific/XDL/Utilities";
import { hideElementOnPrint } from "@pacific/XDL/Utilities/sharedStyles";
import xScreen from "@pacific/XDL/Utilities/xScreen";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            scrim: css`
                ${xScreen("lte", "md")} {
                    top: ${constants.header.tablet.size.height}px;
                }
                ${xScreen("lte", "sm")} {
                    top: ${constants.header.mobile.size.height}px;
                }
                ${hideElementOnPrint}
            `,
            drawerTitle: css`
                display: none;
            `,
            drawerContent: css`
                overflow-x: hidden;
            `,
            drawerBody: css`
                ${xScreen("lte", "md")} {
                    width: 360px;
                    box-shadow: 0 2px 4px 0 ${color("common.ui5", 0.5)}, 0 -2px 0 0 ${color("secondary.main")};
                    top: ${constants.header.tablet.size.height + 2 /* offset by 2 for border */}px;
                }
                ${xScreen("lte", "sm")} {
                    width: 100%;
                    top: ${constants.header.mobile.size.height}px;
                }
                background: ${color("common.ui1")};
            `,
        },
    },
} as xBaseTheme["drawer"];
